import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onReload", "onFilterOption", "placeholder"];
import React, { createRef, useCallback, useEffect, useState } from 'react'; // import { ApolloError } from 'apollo-client';

import { FormattedMessage, useIntl } from 'react-intl-next';
import Select from '@atlaskit/select';
// TODO: FORM-629 Analytics:
// import sendExperienceAnalytics from '@atlassian/jira-common-legacy-do-not-add-anything-new/src/experience-tracking/common/services/send-experience-analytics';
import { MetaActions } from '../../../common/types';
import Control from './control';
import DropdownIndicator from './dropdown-indicator';
import Menu from './menu';
import messages from './messages';
import Option from './option';
export var selectComponents = {
  Control: Control,
  DropdownIndicator: DropdownIndicator,
  IndicatorSeparator: null,
  LoadingIndicator: null,
  Menu: Menu,
  Option: Option
};

var onIsOptionDisabled = function onIsOptionDisabled(option) {
  return 'error' in option ? !!option.error : false;
};

export var BaseSelect = function BaseSelect(_ref) {
  var onReload = _ref.onReload,
      onFilterOption = _ref.onFilterOption,
      placeholder = _ref.placeholder,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var intl = useIntl();
  var onInputChangeProp = restProps.onInputChange,
      inputValueProp = restProps.inputValue;
  var selectRef = /*#__PURE__*/createRef();

  var _useState = useState(inputValueProp || ''),
      _useState2 = _slicedToArray(_useState, 2),
      inputValue = _useState2[0],
      setInputValue = _useState2[1];

  useEffect(function () {
    var current = selectRef.current;

    if (current) {
      current.select.openMenu('first'); // Reset focus as it gets lost if key on AsyncSelect is changed

      current.select.focus();
    }
  }, [selectRef]); // useEffect(() => {
  //   if (options && !(isLoading ?? false)) {
  //     if (isJqlBuilderReportErrorTypeEnabled()) {
  //       let errorType = 'unknown';
  //       if (error instanceof ApolloError) {
  //         if (error.networkError != null) {
  //           errorType = 'networkError';
  //         } else if (error.graphQLErrors.length > 0) {
  //           errorType = 'graphQLError';
  //         }
  //       }
  //       const errorAttributes = error
  //         ? {
  //             errorType,
  //             message: error.message,
  //           }
  //         : null;
  //
  //       sendExperienceAnalytics({
  //         analyticsSource: 'refinement-bar-select',
  //         wasExperienceSuccessful: error == null,
  //         experience: 'showOptions',
  //         application: null,
  //         edition: null,
  //         additionalAttributes: {
  //           filter: fieldKey ?? 'unknown',
  //           ...errorAttributes,
  //         },
  //       });
  //     } else {
  //       sendExperienceAnalytics({
  //         analyticsSource: 'refinement-bar-select',
  //         wasExperienceSuccessful: !isError,
  //         experience: 'showOptions',
  //         application: null,
  //         edition: null,
  //         additionalAttributes: {
  //           filter: fieldKey ?? 'unknown',
  //         },
  //       });
  //     }
  //   }
  // }, [fieldKey, isError, error, isLoading, options]);

  var onInputChange = useCallback(function (newValue, actionMeta) {
    /**
     * Do not clear the filter input value when an input is selected or blurred.
     * NOTE: We are also returning when 'menu-close' event are triggered,
     * which happens when the input is clicked for some reason, but not when we click outside of the dropdown
     * */
    if ([MetaActions.setValue, MetaActions.inputBlur, MetaActions.menuClose].includes(actionMeta.action) && !newValue.length) {
      return;
    } // Reload defaultOptions in case of potential error by changing key on AsyncSelect


    if (actionMeta.action === MetaActions.inputChange && !newValue.length) {
      onReload === null || onReload === void 0 ? void 0 : onReload('');
    }

    onInputChangeProp === null || onInputChangeProp === void 0 ? void 0 : onInputChangeProp(newValue, actionMeta);
    setInputValue(newValue);
  }, [onInputChangeProp, onReload]);
  return /*#__PURE__*/React.createElement(Select, _extends({}, restProps, {
    innerRef: selectRef,
    backspaceRemovesValue: false,
    blurInputOnSelect: false,
    closeMenuOnSelect: false,
    controlShouldRenderValue: false,
    hideSelectedOptions: false,
    isClearable: false,
    isMulti: true,
    inputValue: inputValue,
    menuIsOpen: true,
    menuShouldScrollIntoView: false,
    tabSelectsValue: false,
    noOptionsMessage: function noOptionsMessage() {
      return intl.formatMessage(messages.noOptionsMessage);
    },
    onInputChange: onInputChange,
    isOptionDisabled: onIsOptionDisabled,
    reload: onReload,
    filterOption: onFilterOption,
    placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : /*#__PURE__*/React.createElement(FormattedMessage, messages.searchPlaceholder)
  }));
};